module.exports = "https://static.wanderu.com/ui-react/_next/static/media/flat-iphone.f3bddd0f.png";